import { PartialTranslation } from '../translations';

export const pt_BR: PartialTranslation = {
  newChat: 'Novo Chat',
  search: 'Pesquisar',
  user: 'Usuário',
  settings: 'Configurações',
  language: 'Idioma',
  getHelp: 'Obter ajuda',
  viewAllPlans: 'Ver todos os planos',
  learnMore: 'Saiba mais',
  logOut: 'Sair',
  chooseLanguage: 'Escolher Idioma',
  chooseYourPreferredLanguage: 'Escolha seu idioma preferido',
  searchLanguages: 'Pesquisar idiomas...',
  autoDetect: 'Detecção automática',
  noLanguagesFound: 'Nenhum idioma encontrado',
  askAnything: 'Pergunte qualquer coisa',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Pessoal',
  freePlan: 'Plano gratuito',
  current: 'Atual',
  close: 'Fechar',
  archive: 'Arquivar',
  delete: 'Excluir',
  confirmDelete: 'Tem certeza de que deseja excluir este chat?',
  confirmArchive: 'Tem certeza de que deseja arquivar este chat?',
  deleteCannotUndo: 'Esta ação não pode ser desfeita.',
  archiveCanFind: 'Você pode encontrá-lo na lista de arquivos após o arquivamento.',
  
  // 资源面板
  resources: 'Recursos',
  addResource: 'Adicionar recurso',
  deleteResource: 'Excluir recurso',
  noMatchingResourcesFound: 'Nenhum recurso correspondente encontrado',
  noResourcesAvailable: 'Nenhum recurso disponível',
  hideResources: 'Ocultar recursos',
  showResources: 'Mostrar recursos',
  
  // 聊天输入框
  typeMessage: 'Digite uma mensagem...',
  thinkingOptions: 'Opções de pensamento',
  deleteFile: 'Excluir arquivo',
  clearSelection: 'Limpar seleção',
  addAttachment: 'Adicionar anexo',
  sendMessage: 'Enviar mensagem',
  
  // 思考模式选项
  deepInsight: 'Perspicácia Profunda · Análise Superficial',
  deepInsightDesc: 'Compreensão rápida dos pontos principais',
  deepExploration: 'Exploração Profunda · Análise Abrangente',
  deepExplorationDesc: 'Pesquisa aprofundada multidimensional',
  deepDeconstruction: 'Desconstrução Profunda · Argumento Sistemático',
  deepDeconstructionDesc: 'Análise progressiva camada por camada',
  
  // 写作模式选项
  contractReview: 'Revisão de Contrato · Identificação de Riscos',
  contractReviewDesc: 'Análise de cláusulas e verificação de conformidade',
  textPolish: 'Polimento de Texto · Expressão Profissional',
  textPolishDesc: 'Otimização de linguagem e ajuste estrutural',
  legalDocuments: 'Documentos Legais · Redação Padrão',
  legalDocumentsDesc: 'Redação profissional de documentos legais',

  // 认证和隐私翻译
  login: 'Entrar',
  register: 'Registrar',
  welcomeBack: 'Bem-vindo ao LawHelper',
  loginSubtitle: 'Seu Assistente IA de Pesquisa Jurídica',
  continueWithGoogle: 'Continuar com Google',
  continueWithMicrosoft: 'Continuar com Microsoft',
  continueWithWeChat: 'Continuar com WeChat',
  orContinueWith: 'ou continuar com',
  emailTab: 'E-mail',
  phoneTab: 'Telefone',
  emailPlaceholder: 'Digite seu e-mail',
  phonePlaceholder: 'Digite o número de telefone',
  codePlaceholder: 'Digite o código de 6 dígitos',
  sending: 'Enviando...',
  verifying: 'Verificando...',
  verify: 'Verificar',
  sendMagicLink: 'Enviar link mágico',
  getVerificationCode: 'Obter código',
  resendCode: 'Reenviar código',
  resendIn: 'Reenviar em',
  magicLinkSent: 'Link mágico enviado para seu e-mail',
  magicLinkHint: 'Enviaremos um link seguro para seu e-mail',
  otpSent: 'Código de verificação enviado',
  agreeToTerms: 'Ao continuar, você concorda com nossos',
  privacyPolicy: 'Política de Privacidade',
  termsOfService: 'Termos de Serviço',
  and: 'e',
  privacyTitle: 'Sua privacidade importa',
  privacyIntro: 'Usamos cookies e tecnologias similares para oferecer a melhor experiência.',
  essentialCookies: 'Cookies essenciais',
  essentialDesc: 'Necessários para o funcionamento do site',
  analyticsCookies: 'Cookies analíticos',
  analyticsDesc: 'Nos ajudam a melhorar nosso serviço',
  marketingCookies: 'Cookies de marketing',
  marketingDesc: 'Usados para conteúdo personalizado',
  acceptAll: 'Aceitar tudo',
  essentialOnly: 'Apenas essenciais',
  customize: 'Personalizar',
  savePreferences: 'Salvar preferências',
  back: 'Voltar',
  readPrivacyPolicy: 'Ler nossa política de privacidade',
  cookiePolicy: 'Política de cookies',
  gdprCompliance: 'LGPD/GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Revisão IA',
  aiDraft: 'Redação IA',
  smartAssistant: 'Modelo',

  // 知识库搜索
  enableKnowledgeSearch: 'Ativar pesquisa',
  knowledgeSearchDesc: 'IA pesquisa seus documentos',
  clickToDisable: 'Desativar',
  clickToEnable: 'Ativar',

  // Landing page translations
  tagline: 'Inteligência jurídica com IA',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplificado.',
  jurisdictionsLabel: 'Jurisdições',
  accuracyLabel: 'Precisão',
  fasterLabel: 'Mais rápido',
  availableLabel: 'Disponível',
  platformCapabilities: 'Recursos',
  testimonialQuote: '"LawHelper transformou nosso trabalho."',
  testimonialAuthor: 'Profissional',
  testimonialPosition: 'Sócio',
  viewPricing: 'Preços',
  footerPricing: 'Preços',
  footerPrivacy: 'Privacidade',
  footerTerms: 'Termos',
  footerContact: 'Contato',
  footerCopyright: '© 2024 LawHelper.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Fechar painel de recursos',
  uploading: 'Enviando %{fileName}...',
  processing: 'Processando %{fileName}...',
  uploadSuccess: '✓ %{fileName} enviado com sucesso',
  uploadError: '✗ Falha no envio: %{error}',
  quickAnswer: 'Resposta rápida',
  quickAnswerDesc: 'Resposta rápida para perguntas simples',
  cancelRequest: 'Cancelar',
  library: 'Biblioteca',
  filterAll: 'Tudo',
  filterChat: 'Chats',
  filterReview: 'Revisão',
  filterDraft: 'Rascunho',
  filterTemplate: 'Modelo',
  filterForm: 'Formulário',
  thinking: 'Pensando...',
  thinkingProcess: 'Processo de pensamento',
  analyzingLegalLogic: 'Analisando lógica jurídica...',
  lawhelperThinking: 'Lawhelper está pensando...',
  serviceError: 'Erro do serviço',
  uploaded: 'Enviado',
  settingsGeneral: 'Geral',
  settingsNotifications: 'Notificações',
  settingsAppearance: 'Aparência',
  settingsProfile: 'Perfil',
  settingsResponseNotifications: 'Notificações de resposta',
  settingsResponseNotificationsDesc: 'Notificar quando a IA concluir a resposta',
  settingsColorMode: 'Modo de cor',
  settingsLight: 'Claro',
  settingsDark: 'Escuro',
  settingsSystem: 'Sistema',
  about: 'Sobre',
  reviewTitle: 'Revisão de documento',
  exitReview: 'Sair da revisão',
  uploadPrompt: 'Envie um PDF para iniciar a revisão',
  uploadButton: 'Selecionar arquivo',
  startChatConfig: 'Digite "Revisar este documento" para começar',
  reviewPlaceholder: 'Digite uma mensagem ou "Revisar este documento"...',
  analyzing: 'Revisando...',
  reviewComplete: 'Revisão concluída',
  issuesFound: '%{count} problemas encontrados',
  draftTitle: 'Redação de documento jurídico',
  draftPlaceholder: 'Edite aqui ou peça à IA para gerar...',
  analyzingTemplate: 'Analisando modelo %{name}...',
  templateAnalyzed: '✅ Modelo %{name} analisado! Diga como deseja modificá-lo.',
  templateAnalysisPrompt: 'Analisar cláusulas-chave do modelo',
  parsingFailed: '⚠️ Falha ao analisar o arquivo, mas você pode descrever suas necessidades.',
  generating: 'Gerando...',
  generatedSuccess: '✅ Documento gerado! Veja e edite no editor.',
  drafterWelcome: 'Bem-vindo ao Assistente IA de Documentos',
  drafterYouCan: 'Você pode:',
  drafterUploadTemplate: 'Enviar modelo para análise IA',
  drafterDescribeNeeds: 'Descrever requisitos do documento',
  drafterLetAiHelp: 'A IA ajuda na redação de contratos, acordos, etc.',
  drafterExamples: 'Exemplos:',
  drafterExampleRental: '"Redija um contrato de locação"',
  drafterExampleLabor: '"Preencher contrato de trabalho com base no modelo"',
  drafterInputPlaceholder: 'Descreva suas necessidades documentais...',
  drafterThinking: 'Pensando...',
  drafterHistoryTitle: 'Histórico',
  drafterNoHistory: 'Sem histórico',
  drafterNewChat: 'Novo chat',
  drafterHistory: 'Histórico',
  drafterRemoveAttachment: 'Remover anexo',
  drafterLineHeight: 'Altura da linha',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Exportar como Word (.docx)',
  drafterExportPdf: 'Exportar como PDF',
  drafterSave: 'Salvar documento',
  drafterDownload: 'Baixar documento',
  drafterUndo: 'Desfazer',
  drafterRedo: 'Refazer',
  drafterBold: 'Negrito',
  drafterItalic: 'Itálico',
  drafterStrike: 'Tachado',
  drafterUnderline: 'Sublinhado',
  drafterHighlight: 'Realçar',
  drafterLink: 'Inserir link',
  drafterAlignLeft: 'Alinhar à esquerda',
  drafterAlignCenter: 'Centralizar',
  drafterAlignRight: 'Alinhar à direita',
  drafterAlignJustify: 'Justificar',
  drafterList: 'Lista',
  drafterBulletList: 'Lista com marcadores',
  drafterOrderedList: 'Lista numerada',
  drafterTaskList: 'Lista de tarefas',
  drafterOpenResource: 'Abrir painel de recursos',
  drafterStopGeneration: 'Parar geração',
  drafterAgentMode: 'Modo Agente ativo | Clique para chat normal',
  drafterAgentModeOn: 'Modo Agente ativo | Clique para chat normal',
  drafterAgentModeOff: 'Modo chat normal | Clique para modo Agente',
  drafterUploadAttachment: 'Enviar anexo',
  drafterExit: 'Sair',
  drafterConfirm: 'Confirmar',
  drafterOpenLink: 'Abrir link',
  drafterDeleteLink: 'Excluir link',
  drafterQuote: 'Citação',
  workflowTitle: 'Fluxo de trabalho IA',
  workflowRunning: 'Executando...',
  workflowReady: 'Pronto',
  workflowCompleted: 'Concluído',
  workflowStartFailed: 'Falha ao iniciar o fluxo',
  workflowExecutionFailed: 'Falha na execução do fluxo',
  workflowInterrupted: 'Fluxo interrompido',
  workflowProcessing: 'Processando...',
  workflowStepsCompleted: 'etapas concluídas',
  workflowStepsTotal: 'Fluxo concluído (%{count} etapas)',
  acceptChanges: 'Aceitar alterações',
  rejectChanges: 'Rejeitar alterações',
  changesAccepted: 'Alterações aceitas',
  changesRejected: 'Alterações rejeitadas',
  stopWorkflow: 'Parar',
  restartWorkflow: 'Reiniciar',
  startDrafting: 'Iniciar redação',
  interrupt: 'Parar',
  documentSubject: 'Assunto do documento *',
  documentType: 'Tipo de documento',
  jurisdiction: 'Jurisdição',
  specialRequirements: 'Requisitos especiais (opcional)',
  clickStartDrafting: 'Clique em "Iniciar redação" para começar o fluxo',
  docTypeContract: 'Contrato',
  docTypeAgreement: 'Acordo',
  docTypeNotice: 'Notificação',
  docTypeLetter: 'Carta',
  docTypePetition: 'Petição',
  docTypeWill: 'Testamento',
  docTypePowerOfAttorney: 'Procuração',
  countryChina: 'China',
  countryUSA: 'Estados Unidos',
  countryGermany: 'Alemanha',
  countryJapan: 'Japão',
  countryFrance: 'França',
  countryUK: 'Reino Unido',
  citationVerified: 'Verificado',
  citationUnverified: 'Não verificado',
  imageLoadFailed: 'Falha ao carregar imagem',
  smartDocTitle: 'Assistente inteligente de documentos',
  smartDocChatTitle: 'Assistente IA de documentos',
  smartDocDropPrompt: 'Solte o arquivo PDF aqui',
  smartDocSelectFile: 'Selecionar arquivo',
  smartDocOr: 'ou',
  smartDocWelcomeTitle: 'Bem-vindo ao Assistente IA de Documentos',
  smartDocWelcomeYouCan: 'Você pode:',
  smartDocUploadForAI: 'Enviar modelo para análise IA',
  smartDocDescribeDoc: 'Descrever requisitos do documento',
  smartDocLetAIDraft: 'A IA ajuda na redação de contratos',
  smartDocExamples: 'Exemplos:',
  smartDocExampleRental: '"Redija um contrato de locação"',
  smartDocExampleLabor: '"Preencher contrato de trabalho"',
  smartDocInputPlaceholder: 'Descreva suas necessidades...',
  smartDocRemoveAttachment: 'Remover anexo',
  smartDocOpenResources: 'Abrir painel de recursos',
  smartDocExit: 'Sair',
  reviewStartFailed: 'Falha ao iniciar revisão',
  reviewFailed: 'Revisão falhou',
  reviewFoundIssues: 'Revisão concluída, %{count} problemas encontrados.',
  cannotReadStream: 'Não é possível ler o fluxo de resposta',
  parseEventFailed: 'Falha ao analisar evento do fluxo',
  errorPrefix: 'Erro',
  unknownError: 'Erro desconhecido',
  file: 'Arquivo',
  loading: 'Carregando...',
  localFolders: 'Pastas locais',
  selectLocalFolder: 'Selecionar pasta local',
  reselectFolder: 'Alterar pasta',
  addToContext: 'Adicionar ao chat',
  saveFile: 'Salvar',
  renameFile: 'Renomear',
  fileSaved: 'Arquivo salvo',
  fileRenamed: 'Arquivo renomeado para %{name}',
  browserNotSupported: 'Seu navegador não suporta acesso a pastas locais',
  noFolderSelected: 'Selecione uma pasta local para explorar arquivos',
  scanningFolder: 'Verificando pasta...',
  selectFileToPreview: 'Selecione um arquivo para pré-visualizar',
  aiAnalyze: 'Análise IA',
};
